import React, { useState } from 'react'
import { FiCalendar, FiUser, FiCreditCard, FiPhone, FiMail } from "react-icons/fi"
import { getStatusClass } from '../../utils/data'
import { useTranslation } from 'react-i18next'
import { Booking } from '../../types'
import { FaBed } from 'react-icons/fa'
import ConfirmModal from './models/ConfirmModal'
import { AppDispatch } from '../../store'
import { useDispatch } from 'react-redux'
import { acceptBook, refuseBook } from '../../features/home/bookingSlice'
import ConfirmDeleteModal from './models/ConfirmDeleteModal'
import { Link } from 'react-router-dom'
const BookingCards = ({ bookings }: { bookings: Booking[] }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch<AppDispatch>();
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedBookId, setSelectedBookId] = useState<number | null>(null)
    const handleConfirm = async () => {
        if (selectedBookId !== null) {
            await dispatch(acceptBook(selectedBookId));
            setSelectedBookId(null);
        }
    };
    const handleRefuse = async () => {
        if (selectedBookId !== null) {
            await dispatch(refuseBook(selectedBookId));
            setSelectedBookId(null);
        }

    };
    const confirm = (bookId: number) => {
        setSelectedBookId(bookId)
        setConfirmModalOpen(true);
    };
    const confirmDelete = (bookId: number) => {
        setSelectedBookId(bookId)
        setDeleteModalOpen(true);
    };
    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {bookings.map((booking: any) => (
                    <div
                        key={booking.id}
                        className={`bg-white border overflow-hidden rounded-2xl shadow-sm hover:shadow-lg transition p-5 flex flex-col ${booking.status === "Waiting" ? "border border-secondry " : ""
                            }`}
                    >
                        {/* ID + Status */}
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="font-semibold text-gray-800">#{booking.id}</h3>
                            <p className={` text-sm font-medium ${getStatusClass(booking?.state)}`}  >
                                {booking?.state === "Pending" && booking.paymentMethod === "Cash" ? t("pending-cash") : t(`${booking?.state.toLowerCase()}`) || booking?.state}
                            </p>
                        </div>

                        <p className="flex items-center gap-2 text-sm text-gray-600 mb-3">
                            <FiUser /> {t("user")}:{" "}
                            <span className="font-medium">{booking.userName}</span>
                        </p>


                        <div className="flex gap-5 justify-between text-sm text-gray-600 mb-3">

                            <div className=' flex-1 overflow-hidden text-ellipsis'>
                                <p className="flex items-center gap-1 text-gray-500">
                                    <FiMail className="text-gray-400" />
                                    {t("email")}
                                </p>
                                <p className="font-medium" dir='ltr'>
                                    {booking.email}
                                </p>
                            </div>

                            <div className=' flex-1'>
                                <p className="flex items-center gap-1 text-gray-500">
                                    <FiPhone className="text-gray-400" />
                                    {t("phone")}
                                </p>
                                <p className="font-medium">
                                    {booking.phone}
                                </p>
                            </div>
                        </div>
                        {/* Dates */}
                        <div className="flex justify-between text-sm text-gray-600 mb-3">
                            <div>
                                <p className="flex items-center gap-1 text-gray-500">
                                    <FiCalendar /> {t("check-in")}
                                </p>
                                <p className="font-medium">
                                    {new Date(booking.checkIn).toLocaleDateString()}
                                </p>
                            </div>
                            <div>
                                <p className="flex items-center gap-1 text-gray-500">
                                    <FiCalendar /> {t("check-out")}
                                </p>
                                <p className="font-medium">
                                    {new Date(booking.checkOut).toLocaleDateString()}
                                </p>
                            </div>
                        </div>
                        <Link
                            className=' text-textSecond font-medium text-sm'
                            to={booking.place.type === "Stay" ? `/dashboard/stay-booking-report/${booking.place.id}` : `/dashboard/hall-booking-report/${booking.place.id}`}>
                            {booking.place.title}
                        </Link>
                        {/* Rooms */}
                        {booking.rooms?.length > 0 && (
                            <div className="mb-3">
                                <p className="text-sm font-semibold text-gray-700">{t("rooms")}</p>
                                <div className="space-y-1 mt-1">
                                    {booking.rooms.map((room: any) => (
                                        <div
                                            key={room.id}
                                            className="text-xs flex gap-1 text-gray-600 border rounded-md px-2 py-1 bg-gray-50"
                                        >
                                            <FaBed /> {room.type} #{room.roomNumber} — {room.pricePerNight}
                                            {room.currencyCode}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Optional Services */}
                        {booking.optionalServices?.length > 0 && (
                            <div className="mb-3">
                                <p className="text-sm font-semibold text-gray-700">
                                    {t("optional-services")}
                                </p>
                                <ul className="list-disc pl-5 text-xs text-gray-600 mt-1">
                                    {booking.optionalServices.map((srv: any) => (
                                        <li key={srv.id}>
                                            {srv.title} ({srv.price}
                                            {srv.currencyCode})
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {/* Total + Payment */}
                        <div className="flex justify-between items-center border-t pt-3 mt-auto">
                            <p className="font-semibold text-gray-800">
                                💰 {booking.price.toFixed(2)} {booking.currency}
                            </p>
                            <span className="flex items-center gap-1 text-xs text-gray-500">
                                <FiCreditCard /> {t("payment-method")}: {booking.paymentMethod}
                            </span>
                        </div>
                        {booking.status === "Waiting" && (
                            <div className='mt-4 text-sm flex gap-2 font-medium flex-row'>
                                <button
                                    className="text-white bg-red-600 hover:bg-red-700 rounded-lg w-full py-2 px-4 transition"
                                    onClick={() => {
                                        confirmDelete(booking.id)
                                    }}
                                >
                                    {t("refuse")}
                                </button>
                                <button
                                    className=" bg-primary hover:bg-[#00470f] w-full text-white py-2 px-4 rounded-lg transition"
                                    onClick={() => {
                                        confirm(booking.id)
                                    }}
                                >
                                    {t("accept")}
                                </button>
                            </div>

                        )}
                    </div>
                ))}
            </div>
            <ConfirmModal
                isOpen={confirmModalOpen}
                onClose={() => setConfirmModalOpen(false)}
                onConfirm={handleConfirm}
                messageKey="accept-booking-confirm"
            />
            <ConfirmDeleteModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleRefuse}
                messageKey="refuse-booking-confirm"
            />
        </div>
    )
}

export default BookingCards